import React from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import {
  performLogin as performLoginAction,
  setLoginMode,
  setPassword,
  setUsername,
} from '../../../Actions/Login.action';
import { useTypedSelector } from '../../../Hooks/useTypedSelector';
import { translate } from '../../../Services/translation';
import LoginMode from '../../../Types/LoginMode';
import Button from '../../Button';
import Input from '../../Inputs/Input';
import { StyledLogin } from '../styles/LoginForm.styles';
import { TextSeparator } from '../../TextSeparator';
import VippsButton from '../../VippsLogin/VippsButton';
import { getColor } from '../../../styling/mixins/colors';
import { VIPPS_BUTTON_TYPE } from '../../../constants';

const StyledLoginForm = styled(StyledLogin)``;

const LoginForm = () => {
  const { isLoading, registerUserUrl, username = '', password = '' } = useTypedSelector(
    (state) => state.login
  );
  const dispatch = useDispatch();

  const performLogin = (e?: any) => {
    if (e) {
      e.preventDefault();
    }
    dispatch(performLoginAction(username, password));
  };

  return (
    <StyledLoginForm>
      <h3 className='text-center font-black'>{translate('general.login')}</h3>

      <VippsButton type={VIPPS_BUTTON_TYPE.Login} />
      <TextSeparator textToShow={translate('general.separator-text')} />

      <form className="form" onSubmit={performLogin}>
        <Input
          inputSize="large"
          wrapperClassName="input__wrapper"
          placeholder={translate('general.username')}
          onChange={(e) => dispatch(setUsername(e.target.value))}
          disabled={isLoading}
          autoComplete="username"
        />
        <Input
          inputSize="large"
          wrapperClassName="input__wrapper"
          placeholder={translate('general.placeholder.password')}
          onChange={(e) => dispatch(setPassword(e.target.value))}
          disabled={isLoading}
          type="password"
          id="password"
          autoComplete="current-password"
        />
        <Button
          btnSize="medium"
          btnType="clear"
          onClick={(e) => {
            e.preventDefault();
            dispatch(setLoginMode(LoginMode.ForgotPassword))
          }}
          disabled={isLoading}
          className="additional__btn !text-gray-400 !p-0"
          type="button"
        >
          {translate('login.forgot-password')}
        </Button>
        <Button
          btnSize="xlarge"
          btnType={`${username === '' || password === '' ? 'grayed' : 'secondary'}`}
          fullwidth={true}
          type="submit"
          className="submit !mt-9"
          disabled={isLoading && username === '' || password === '' ? true : false}
        >
          {!isLoading && translate('general.login')}
          {isLoading && translate('general.loading')}
        </Button>
      </form>
      <div >

        {registerUserUrl && registerUserUrl != '' &&
          <Button
            btnSize="xlarge"
            btnType="primary"
            fullwidth={true}
            onClick={() => window.location.href = registerUserUrl}
            disabled={isLoading}
            className="submit"
          >
            {translate('login.opprett-ny-konto')}
          </Button>
        }

      </div>
    </StyledLoginForm>
  );
};

export default LoginForm;
